import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import WSButton from "../../Components/Button/WSButton";
import {
  Box,
  Typography,
  Divider,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress
} from "@mui/material";

// import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { NotFound } from "./NotFound";
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import logo from "../../images/logo-laundry-crm.bmp";

// const columns: IColumns[] = [
//   { header: "#", fieldName: "id", sortable: true },
//   { header: "Product Name", fieldName: "name", type: "default" },
//   { header: "Rate", fieldName: "price", type: "default", sortable: true },
//   { header: "Service", fieldName: "service", type: "default", sortable: true }
// ];

// bills={bills} orderType={orderType}
const BillView: React.FC = () => {
  const { id } = useParams();
  const contentRef = useRef<HTMLDivElement>(null);
  const { showMessage } = useSnackbar();

  const [bill, setBill] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const billingAddress = {
    name: "Willsoar",
    address: "Kannur",
    phone: "+133 456 7890"
    // taxId: "13456789"
  };

  useEffect(() => {
    async function getOrderById(orderId: string) {
      try {
        const response: any = await callAPI(
          "orders",
          Method.GET,
          null,
          orderId
        );
      

        if (response?.data) {
          setBill(response.data); // ✅ Correctly updating state
        }
      } catch (error) {
        console.error("Failed to retrieve data", error);
        showMessage("Something went wrong. Please try again.", "error");
      } finally {
        setLoading(false);
      }
    }

    if (id) {
      getOrderById(id);
    }
  }, [id]);

  // // 🖨️ Print Handler
  // const handlePrint = useReactToPrint({
  //   contentRef
  // });

  if (loading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        width="100%"
      >
        <CircularProgress />
      </Box>
    );
  if (!bill) return <NotFound />;

  const handlePrint = () => {
    const printWindow = window.open("", "_blank", "width=800,height=600");
  
    const orderRows = bill.orderItems
      .map((item: any, index: number) => {
        return `
        <tr>
          <td>${index + 1}</td>
          <td>${item.productName}</td>
          <td>${item.quantity}</td>
          <td>${item.price}</td>
          <td>${item.quantity * item.price}</td>
        </tr>
        <tr class="divider-row"><td colspan="5"></td></tr>
      `;
      })
      .join("");

    const totalQuantity = bill.orderItems.reduce((sum:number, item:any) => sum + item.quantity, 0);
  
    printWindow?.document.write(`
      <html>
        <head>
          <title>Receipt</title>
          <style>
            @media print {
              body {
                font-family: Arial, sans-serif;
                margin: 0;
                padding: 0;
              }
  
              .print-receipt {
                width: 80mm;
                max-width: 80mm;
                font-size: 12px;
                margin: 0 auto;
                padding: 6px;
              }
  
              .logo {
                text-align: center;
                margin-bottom: 6px;
              }
  
              .logo h1 {
                font-size: 22px;
                margin: 0;
                font-weight: bold;
              }
  
              .logo h2 {
                font-size: 16px;
                margin: 2px 0;
                font-weight: normal;
              }
  
              table {
                width: 100%;
                border-collapse: collapse;
              }
  
              table th, table td {
                padding: 4px;
                font-size: 12px;
                text-align: center;
                border: none;
              }
  
              table thead {
                border-top: 2px solid #000;
                border-bottom: 1px dashed #000;
              }
  
              .divider-row td {
                border-bottom: 1px dashed #000;
              }
  
              .summary {
                display: flex;
                justify-content: space-between;
                font-weight: bold;
                font-size: 14px;
                margin-top: 10px;
              }
  
              .section {
                margin: 6px 0;
              }
  
              .terms p {
                font-size: 10px;
                margin: 2px 0;
              }
  
              hr {
                border: none;
                border-top: 1px dashed #999;
                margin: 6px 0;
              }
  
              .thank-you {
                text-align: center;
                margin-top: 10px;
                font-size: 14px;
                font-weight: bold;
              }
                .bold{
                font-size: 14px;
                font-weight: bold;
                }

                .container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.section .b{
flex: 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  }


            }
          </style>
        </head>
        <body>
          <div class="print-receipt">
            <div class="logo">
  <h1>3 FOLD</h1>
  <h2>Laundry & Dry Cleaners</h2>
  <p>Email: www.3foldlaundry.com</p>
  <p>Phone: 9072512525, 04996292525</p>
  <p>Address: Iringannur road,Edacheri</p>
</div>

<div class="container">
  <div class="section b">
    <p class="bold">Invoice: ${bill.orderNumber}</p>
    <p>Date: ${new Date(bill.orderDate).toLocaleDateString()}</p>
    <p>Total Amount: ₹${bill.finalAmount}</p>
    <p>Payment Status: ${bill.orderStatus}</p>
  </div>

  <div class="section">
    <p>Customer Name: ${bill.customerName}</p>
    <p>Phone Number: ${bill.phoneNumber}</p>
  </div>
</div>


  
            <hr/>
  
            <div class="section">
              <span class="bold">Order Items:</span>
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Product</th>
                    <th>Qty</th>
                    <th>Price (₹)</th>
                    <th>Amount (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  ${orderRows}
                </tbody>
              </table>
            </div>
  
            <div class="summary">
              <div>Total Qty: ${totalQuantity}</div>
              <div>Total Amount: ₹${bill.finalAmount}</div>
            </div>
  
            <hr/>
  
            <div class="terms">
              <div class="heading">Terms & Conditions</div>
              <p>1. Check articles for damage at delivery & report within 24 hrs.</p>
              <p>2. Not responsible for shrinkage, discoloration, unseen defects.</p>
              <p>3. Articles left 15+ days may incur extra charges or disposal.</p>
              <p>4. Stain removal is not guaranteed; cleaned at owner’s risk.</p>
              <p>5. Max compensation: ₹3,000 or 6x cleaning cost.</p>
              <p>6. Claims on washing quality must be within 2 days of delivery.</p>
            </div>
  
            <div class="thank-you">
              Thank You, Come Again!
            </div>
          </div>
        </body>
      </html>
    `);
  
    printWindow?.document.close();
    printWindow?.focus();
    printWindow?.print();
};


  return (
    <Box p={2}>
      <Box ref={contentRef} p={2} className="print-receipt">
        {/* Logo Section */}
        <Box display="flex" flexDirection="column" alignItems="center" mr={1}>
          <Typography variant="h4" fontWeight="bold" mb={0}>
            3 FOLD
          </Typography>
          <Typography variant="h6" fontWeight="bold" mt={0}>
            Laundry & DryCleaners
          </Typography>
        </Box>

        {/* Invoice Header */}
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          textAlign={"center"}
          mt={2}
          mr={2}
        >
          <Grid item>
            <Typography variant="body2" fontWeight="bold">
              Invoice: {bill.orderNumber}
            </Typography>
            <Typography variant="body2">
              Date: {new Date(bill.orderDate).toLocaleDateString()}
            </Typography>
            <Typography variant="body1">
              Total Amount: ₹{bill.finalAmount}
            </Typography>
            <Typography variant="body2">
              Payment Status: {bill.orderStatus}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 1 }} />

        {/* Delivery Address (if applicable) */}
        {/* {bill.isHomeDelivery && (
          <Grid item xs={13}>
            <Typography variant="subtitle2" fontWeight="bold">
              Delivery Address:
            </Typography>
            <Typography variant="body2">{bill.customerName}</Typography>
            <Typography variant="body2">{bill.deliveryAddress}</Typography>
            <Typography variant="body2">Phone: {bill.phoneNumber}</Typography>
          </Grid>
        )} */}

        <Divider sx={{ my: 1 }} />

        {/* Order Items Table */}
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          Order Items:
        </Typography>
        <Box>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Product</TableCell>
                <TableCell sx={{ width: 100, textAlign: "right" }}>
                  Qty
                </TableCell>
                <TableCell>Price (₹)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bill.orderItems.map((item: any, index: number) => (
                <TableRow key={item.orderItemId}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{item.productName}</TableCell>
                  <TableCell>{item.quantity}</TableCell>
                  <TableCell>{item.price}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>

        {/* Payment Summary */}
        <Grid
          container
          justifyContent="flex-end"
          textAlign="right"
          mt={1}
          mr={2}
        >
          <Grid item>
            <Typography
              variant="subtitle2"
              fontWeight="bold"
              textAlign={"right"}
              mr={5}
            >
              Total Amount: ₹{bill.finalAmount}
            </Typography>
          </Grid>
        </Grid>

        {/* Terms & Conditions */}
        <Box mt={1} p={1} borderRadius={1}>
          <p
            style={{
              fontWeight: "bold",
              marginBottom: "4px",
              fontSize: "14px"
            }}
          >
            Terms & Conditions
          </p>
          <p style={{ fontSize: "8px", margin: "2px 0" }}>
            1. Check articles for damage at delivery & report within 24 hrs.
          </p>
          <p style={{ fontSize: "8px", margin: "2px 0" }}>
            2. Not responsible for shrinkage, discoloration, unseen defects.
          </p>
          <p style={{ fontSize: "8px", margin: "2px 0" }}>
            3. Articles left 15+ days may incur extra charges or disposal.
          </p>
          <p style={{ fontSize: "8px", margin: "2px 0" }}>
            4. Stain removal is not guaranteed; cleaned at owner’s risk.
          </p>
          <p style={{ fontSize: "8px", margin: "2px 0" }}>
            5. Max compensation: ₹3,000 or six times the cleaning cost.
          </p>
          <p style={{ fontSize: "8px", margin: "2px 0" }}>
            6. Claims on washing quality must be within 2 days of delivery.
          </p>
        </Box>

        <Box mt={1} p={1} borderRadius={1}>
          <p
            style={{
              fontWeight: "bold",
              marginBottom: "4px",
              fontSize: "14px"
            }}
          >
            Compensation & Disclaimer
          </p>
          <p style={{ fontSize: "8px", margin: "2px 0" }}>
            1. Not responsible for personal items left in garments.
          </p>
          <p style={{ fontSize: "8px", margin: "2px 0" }}>
            2. We reserve the right to refuse cleaning certain garments.
          </p>
          <p style={{ fontSize: "8px", margin: "2px 0" }}>
            3. Not liable for losses due to fire, burglary, unforeseen events.
          </p>
          <p style={{ fontSize: "8px", margin: "2px 0" }}>
            4. No refunds for delays; extra processing time may be needed.
          </p>
        </Box>
      </Box>

      <Grid container>
        <WSButton
          id="printBtn"
          label="Print Invoice"
          variant="contained"
          color="primary"
          onClick={handlePrint}
          sx={{ mt: 2, width: "100%" }}
        />
      </Grid>

      {/* Print Styles */}
      <style>{`
 @media print {
  .print-receipt {
    width: 80mm;
    max-width: 80mm;
    font-size: 8px;
    line-height: 1.2;
    margin: 0 auto;
    padding: 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0;
    padding: 0;
  }

  table th,
  table td {
    padding: 0 !important;
    margin: 0 !important;
    font-size: 8px;
    line-height: 1.2;
    border: none;
  }

  /* Align # to right */
  table th:nth-child(1),
  table td:nth-child(1) {
    text-align: right;
  }

  /* Align Product to left */
  table th:nth-child(2),
  table td:nth-child(2) {
    text-align: left;
  }

  /* Align Qty to right */
  table th:nth-child(3),
  table td:nth-child(3),
  /* Align Price to right */
  table th:nth-child(4),
  table td:nth-child(4) {
    text-align: right;
  }

  .MuiTableCell-root {
    padding: 0 !important;
  }
}


`}</style>
    </Box>
  );
};

export default BillView;
